import script from "./ActivityMsg.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityMsg.vue?vue&type=script&setup=true&lang=js"

import "./ActivityMsg.vue?vue&type=style&index=0&id=89c9e114&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89c9e114"]])

export default __exports__